import {cashBoxHeaderFilter} from "../../../hoc/cashBoxHeaderFilter";

const CashBoxOperationDataTableHeader = cashBoxHeaderFilter(null,"CashBoxDataTableHeader")

export default CashBoxOperationDataTableHeader
